import { defineStore } from 'pinia'
import { DevLog } from "@/helpers/consoleHelpers"

export const useSettingStore = defineStore('setting', {
    state: (): ISettingState => ({
        timer: null,
        refreshInProgress: false
    }),
    actions: {
        clearLoadingInterval(): void {
            if (this.timer) {
                // Log the information (dev only)
                DevLog.log("Clearing timer " + this.timer)
    
                // Clear the timer.
                clearInterval(this.timer) 
                this.timer = null
            }
        },
        setLoadingInterval(fn: CallableFunction, interval: number): void {
            // Clear any existing timer then create a new one.
            this.clearLoadingInterval()
            this.timer = setInterval(fn, interval)
    
            // Log the information (dev only)
            DevLog.log("Setting new timer " + this.timer)
        },
        setRefreshStateInProgress(inProgress = true): void {
            this.refreshInProgress = inProgress
        },
        reset(): void {
            this.$reset()
        }
    },
    getters: {
        isLoading(state: ISettingState): boolean {
            return state.refreshInProgress
        }
    },
    persist: {
        storage: sessionStorage
    },
})

interface ISettingState {
    timer: number|null,
    refreshInProgress: boolean
}

export type SettingStore = ReturnType<typeof useSettingStore>